import { ApolloCache, useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { EXPIRE_ORG, GET_CHILD_ORGS, GET_ORG_RELATIONSHIPS, GET_ROOT_ORGS } from '../../../graphql/org-gql';
import { LOCALES } from '../../../i18n/locales';
import { messages } from '../../../i18n/message';
import { notifySuccess } from '../../../services/notification';
import { IOrg } from '../../../types/org';
import { CloseIcon, DeleteIcon } from '../../common/icons';
import { CannotExpire } from './org-details';
import SpinnerOverlay from '../../common/spinner/spinner';
import Button from '../../common/button';

interface ExpireOrganizationProps {
    isOpen: boolean,
    toggle: () => void,
    org: IOrg,
    onOrgSelect?: (org: IOrg | undefined) => void;
}

const ExpireOrganization = (props: ExpireOrganizationProps) => {
    const {isOpen, toggle, org,onOrgSelect} = props

    const [cannotExpireOrgOpen, setCannotExpireOrgOpen] = useState<boolean>(false)
    const [expireByOtherOpen, setExpireByOtherOpen] = useState<boolean>(false)
    //const [sharedToParentOrgIds,setSharedToParentOrgIds]=useState<number[]>([])
    const toggleCannotExpireOrganization = useCallback(() => {
        setCannotExpireOrgOpen(!cannotExpireOrgOpen)
    }, [cannotExpireOrgOpen])

    const toggleExpireByOther = useCallback(() => {
        setExpireByOtherOpen(!expireByOtherOpen)
    }, [expireByOtherOpen])

    const [expireOrg,{loading}] = useMutation(EXPIRE_ORG)

    const getRefetchQuery = () => {
        let query : any = []
        if(org.parentOrg){
            query = [...query,{query: GET_CHILD_ORGS,variables: { id: org.parentOrg.id}},{query:GET_ORG_RELATIONSHIPS,variables: {orgId:org.parentOrg.id}}];
        }else{
            query = [...query,{query: GET_ROOT_ORGS, variables: { categoryId: org.details.category.id}}]
        }
   
        return query;
    }

    const updateCache = (cache : ApolloCache <any>) => {
        
        //remove childOrgs
        cache.evict({ id: 'ROOT_QUERY', fieldName: 'childOrgs' });
        cache.gc();
    }

    const handleExpire = (org:IOrg) => {
        try {
            expireOrg({
                variables: {orgId: org.id},
                refetchQueries: getRefetchQuery(),
                awaitRefetchQueries: true,
                update(cache){updateCache(cache)},

            }).then(response => {
                if (response.data?.expireOrg.success) {
                    console.log("successfully expired org: ", response.data.expireOrg)
                    toggle()
                    notifySuccess()
                    onOrgSelect && onOrgSelect(undefined)
                    return

                }else if(response.data?.expireOrg.code==='V1003'){
                    console.log("didnt expire: ",org.id, response.data?.expireOrg.code)
                    toggle()
                    toggleExpireByOther()
                }
                else{
                    console.log("didnt expire: ",org.id, response.data?.expireOrg.code)
                    toggle()
                    toggleCannotExpireOrganization()
                }
            })

        } catch (err) {
            console.log(err)
        }
        return
    }

    return (
        <>
            {(loading) && <SpinnerOverlay/>}
            <Start isOpen={isOpen} toggle={toggle} handleExpire={()=>handleExpire(org)}/>
            <CannotExpire isOpen={cannotExpireOrgOpen} message={messages[LOCALES.ENGLISH].INFO['2.2']} toggle={toggleCannotExpireOrganization}/>
            <CannotExpire isOpen={expireByOtherOpen} message={messages[LOCALES.ENGLISH].INFO['2.3']} toggle={toggleExpireByOther}/>
        </>
  )
}

export default ExpireOrganization

interface StartProps {
    isOpen: boolean
    toggle: () => void
    handleExpire: () => void
}

const Start = (props: StartProps) => {
    const {isOpen, toggle, handleExpire} = props

    return (
        <Modal size="md" isOpen={isOpen} toggle={toggle} backdrop="static">
            <ModalHeader 
                toggle={toggle} 
                tag={'h2'}
                cssModule={{'modal-title': 'w-100 text-center'}}>
                    Expire Organization?
            </ModalHeader>
            <ModalBody style={{ textAlign: 'center' }}>
                <div dangerouslySetInnerHTML={{__html: messages[LOCALES.ENGLISH].INFO['2.1']}} />
            </ModalBody>
            <ModalFooter >
                <Button color="danger" onClick={handleExpire}><DeleteIcon /> Expire</Button>
                <Button color="secondary" onClick={toggle}><CloseIcon /> Cancel</Button>
            </ModalFooter>
        </Modal>
    )
}
